export default __webpack_public_path__ + "static/media/Black-lecture.d8225ae9.svg";